// Skills Icons
import autoCadIcon from "./images/autocad.svg"
import sketchupIcon from "./images/google-sketchup.svg"
import vrayIcon from "./images/v-ray.svg"
import designIcon from "./images/design.svg"
import threedsmaxIcon from "./images/3ds-max.svg"
import revitIcon from "./images/revit.svg"

// Social Icon

import instagramIcon from "./images/instagram.svg"
import behanceIcon from "./images/code.svg"

export default {
  //(Please Do Not Remove The comma(,) after every variable)
  //Change The Website Template

  //   Header Details ---------------------
  name: "Dilara",
  headerTagline: [
    //Line 1 For Header
    "RDT",
    //Line 2 For Header
    "İç",
    //Line 3 For Header
    "Mimarlık",
  ],
  //   Header Paragraph
  headerParagraph:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.",

  //Contact Email
  contactEmail: "dilarayaldz@gmail.com",

  // End Header Details -----------------------

  // Work Section ------------------------
  projects: [
    {
      title: "Proje 1", //Project Title - Add Your Project Title Here
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://mir-s3-cdn-cf.behance.net/project_modules/1400/28642c118618047.608c76add8477.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://www.behance.net/gallery/118618047/SSUA-DENTAL-CLINIC",
    },
    {
      title: "Proje 2", //Project Title - Add Your Project Title Here
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://mir-s3-cdn-cf.behance.net/projects/404/9e1379114699801.Y3JvcCwxODU4LDE0NTQsMTg0LDA.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://www.behance.net/gallery/114699801/HOME-OFFICE",
    },
    {
      title: "Proje 3", //Project Title - Add Your Project Title Here
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://mir-s3-cdn-cf.behance.net/projects/404/fbc75b114442659.Y3JvcCwxNTM5LDEyMDQsMTc1LDA.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://www.behance.net/gallery/114442659/BEDROOM-DESIGN",
    },
    {
      title: "Proje 4", //Project Title - Add Your Project Title Here
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://mir-s3-cdn-cf.behance.net/projects/404/ef50d5114441129.Y3JvcCwyMzk3LDE4NzUsNTMsMA.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://www.behance.net/gallery/114441129/ART-ATELIER",
    },
    {
      title: "Proje 5", //Project Title - Add Your Project Title Here
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://mir-s3-cdn-cf.behance.net/projects/404/4e0cbd102939139.Y3JvcCwxMDU0LDgyNSwyMDYsMA.png",
      //Project URL - Add Your Project Url Here
      url: "behance.net/gallery/102939139/SOFT-DRESSING-ROOM",
    },
    {
      title: "Proje 6", //Project Title - Add Your Project Title Here
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://mir-s3-cdn-cf.behance.net/projects/404/df5c6796486649.Y3JvcCwxMDM5LDgxMiwyMjMsOTA.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://www.behance.net/gallery/96486649/REDREEN",
    },

    /*
    If You Want To Add More Project just Copy and Paste This At The End
    ,{
        title: 'Project Five',
        para: 'Something Amazing',
        imageSrc: "",
        url: ''
    }
    */
  ],

  // End Work Section -----------------------

  // About Secton --------------
  aboutParaOne:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
  aboutParaTwo:
    "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  aboutParaThree:
    "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  aboutImage:
    "https://images.unsplash.com/photo-1519713958759-6254243c4a53?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80",

  //   End About Section ---------------------

  // Skills Section ---------------

  //   Import Icons from the top and link it here

  skills: [
    {
      img: autoCadIcon,
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    },
    {
      img: threedsmaxIcon,
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    },
    {
      img: vrayIcon,
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    },
    {
      img: sketchupIcon,
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    },
    {
      img: revitIcon,
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    },
    {
      img: designIcon,
      para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    },
  ],
  work: [
    // Add Or Remove The Link Accordingly

    {
      mainTech: ["sasas", "xasasa"],
      technologies: ["sasas", "xasasa"],
      years: "123",
      title: "12121",
      company: "dssadsad",
    },
    {
      mainTech: ["sasas", "xasasa"],
      technologies: ["sasas", "xasasa"],

      years: "123",
      title: "12121",
      company: "dssadsad",
    },
    {
      mainTech: ["sasas", "xasasa"],
      technologies: ["sasas", "xasasa"],

      years: "123",
      title: "12121",
      company: "dssadsad",
    },
    {
      mainTech: ["sasas", "xasasa"],
      technologies: ["sasas", "xasasa"],

      years: "123",
      title: "12121",
      company: "dssadsad",
    },
  ],
  // End Skills Section --------------------------

  //   Promotion Section --------------------------

  promotionHeading: "Heading",
  promotionPara:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  // End Promotion Section -----------------

  //   Contact Section --------------

  contactSubHeading: "Yeni projelere imza atalım",
  social: [
    // Add Or Remove The Link Accordingly

    {
      img: behanceIcon,
      url: "https://www.behance.net/dilarayald24ce",
    },

    {
      img: instagramIcon,
      url: "https://www.instagram.com/rdtworks/",
    },
  ],

  // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
